import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserDataShared } from '../models/interface/userData.interface';
import { PermissionDeliveryOption } from '../sharedModules/permission/keys/permissionDelivery.interface';
import { PermissionService } from '../sharedModules/permission/permission.service';
@Injectable({
  providedIn: 'root',
})
export class MuChatService {
  freshChatDomain = 'https://wchat.freshchat.com';
  constructor(private permissionService: PermissionService) { /** */ }

  /**
   * show chat
   */
  openChatFC(): void {
    if ((window as any).fcWidget.isOpen() !== true) {
      (window as any).fcWidget.open();
    }
  }

  /**
   * hide chat
   */
  closeChatFC(): void {
    (window as any).fcWidget.close();
  }

  /*
   * Try to load the freshchat library
   */
  loadFreshChat() {
    return new Promise<boolean>((resolve, _) => {
      const s = document.createElement('script');
      s.addEventListener('load', () => resolve(true));
      s.addEventListener('error', () => resolve(false));
      s.src = this.freshChatDomain + '/js/widget.js';
      s.type = 'text/javascript';
      s.async = true;
      s.defer = true;
      document.head.appendChild(s);
    });
  }

  /**
   * init freshchat
   */
  async initFreshChat(userData: UserDataShared) {
    await this.destroyChat();
    await this.loadFreshChat();
    const userParams = {
      externalId: userData.id,
      firstName: userData.name,
      email: userData.email,
      phone: userData.userPhone,
      companyId: userData.companyId,
    };
    const removeChat = await this.permissionService.canAccess(PermissionDeliveryOption.DELIVERY_ORDER_REMOVE_CHAT);
    if (removeChat) {
      await this.destroyChat();
      return environment.guardClause;
    }
    if ((window as any).fcWidget.isInitialized()) {
      (window as any).fcWidget.user.setProperties(userParams);
    }
    await this.initFreshChatWidget({
      ...environment.freshChat,
      ...userParams,
    } as any);
  }

  /**
   * init widget
   * @param userData
   */
  public async initFreshChatWidget(cfgData: any) {
    if ((window as any).fcWidget) {
      (window as any).fcWidget.init(cfgData);
    }
  }

  /**
   * Destroy chat
   */
  public async destroyChat() {
    if ((window as any).fcWidget) {
      (window as any).fcWidget.destroy();
    }
  }
}
